import React from 'react'
import { Filter } from './Filter'
import '../../styles/filterCard.scss'
import { capitalizeWord } from 'helpers'
import { FilterType } from 'types/clientFiltersTypes'

const FilterCard = ({
    filterTitle,
    filterIcons,
    viewMoreFilters,
    resetSearchValue,
    onFilterSelect
}: {
    filterTitle: string
    filterIcons: FilterType[]
    resetSearchValue: () => void
    viewMoreFilters: (value: React.SetStateAction<boolean>) => void
    onFilterSelect: () => void
}) => {
    return (
        <div className="filter-card">
            <p>{capitalizeWord(filterTitle)}</p>
            <div className="filter-card--filters">
                {filterIcons.map((filter) => (
                    <Filter
                        key={filter.filterName}
                        filter={filter}
                        resetSearchValue={resetSearchValue}
                        viewMoreFilters={viewMoreFilters}
                        onFilterSelect={onFilterSelect}
                    />
                ))}
            </div>
        </div>
    )
}

export default React.memo(FilterCard)
